import { CloudUpload, FileText } from 'lucide-react';
import translations from '../../../../translations/PurchaseInvoiceTranslation';

const DropZone = ({ 
    isDragging, 
    onDragEnter, 
    onDragLeave, 
    onDragOver, 
    onDrop, 
    onClick, 
    fileInputRef, 
    onFileInput,
    styles 
  }) => {
    return (
      <div style={{ position: 'relative', minHeight: '300px' }}>
        <style>
          {`
            @keyframes gentlePulse {
              0%, 100% { 
                opacity: 0.3; 
                transform: scale(1); 
              }
              50% { 
                opacity: 0.5; 
                transform: scale(1.08); 
              }
            }
            @keyframes gentleFloat {
              0%, 100% { 
                transform: translateY(0px) translateX(0px); 
                opacity: 0.25; 
              }
              50% { 
                transform: translateY(-18px) translateX(8px); 
                opacity: 0.5; 
              }
            }
            @keyframes iconFloat {
              0%, 100% { 
                transform: translateY(0px); 
              }
              50% { 
                transform: translateY(-12px); 
              }
            }
            @keyframes gentleShimmer {
              0%, 100% { background-position: 0% 50%; }
              50% { background-position: 100% 50%; }
            }
            @keyframes gentleRipple {
              0% { transform: scale(1); opacity: 0.3; }
              100% { transform: scale(2); opacity: 0; }
            }
            @keyframes gentleBounce {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
            }
          `}
        </style>

        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '350px',
          height: '350px',
          background: 'radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, rgba(59, 130, 246, 0.15) 50%, transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(50px)',
          animation: 'gentlePulse 5s ease-in-out infinite',
          pointerEvents: 'none',
          zIndex: 0
        }}></div>

        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              width: '12px',
              height: '12px',
              background: `rgba(59, 130, 246, ${0.25 + (i % 3) * 0.15})`,
              borderRadius: '50%',
              left: `${5 + i * 12}%`,
              top: `${10 + (i % 4) * 22}%`,
              animation: `gentleFloat ${4 + i * 0.5}s ease-in-out infinite`,
              animationDelay: `${i * 0.4}s`,
              pointerEvents: 'none',
              zIndex: 0,
              boxShadow: '0 0 10px rgba(59, 130, 246, 0.3)'
            }}
          ></div>
        ))}

        <div
          style={{
            ...styles.dropzone,
            position: 'relative',
            zIndex: 1,
            transition: 'all 0.7s ease-out',
            transform: isDragging ? 'scale(1.015)' : 'scale(1)',
            boxShadow: isDragging 
              ? '0 20px 25px -5px rgba(59, 130, 246, 0.2), 0 10px 10px -5px rgba(59, 130, 246, 0.15)' 
              : '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            ...(isDragging ? {
              borderColor: '#3b82f6',
              backgroundColor: '#f0f9ff'
            } : {})
          }}
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          onDragOver={onDragOver}
          onDrop={onDrop}
          onClick={onClick}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={styles.hiddenInput}
            multiple
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={onFileInput}
          />

          {isDragging && (
            <div style={{
              position: 'absolute',
              inset: 0,
              borderRadius: '12px',
              background: 'linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd, #60a5fa, #3b82f6)',
              backgroundSize: '300% 100%',
              animation: 'gentleShimmer 4s ease-in-out infinite',
              padding: '2px',
              opacity: 1,
              transition: 'opacity 1s ease-out',
              pointerEvents: 'none'
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
                borderRadius: '12px'
              }}></div>
            </div>
          )}

          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              {isDragging && (
                <>
                  <div style={{
                    position: 'absolute',
                    inset: '-16px',
                    background: 'rgba(59, 130, 246, 0.25)',
                    borderRadius: '50%',
                    animation: 'gentleRipple 2.5s ease-out infinite',
                    pointerEvents: 'none'
                  }}></div>
                  <div style={{
                    position: 'absolute',
                    inset: '-16px',
                    background: 'rgba(59, 130, 246, 0.2)',
                    borderRadius: '50%',
                    animation: 'gentleRipple 2.5s ease-out infinite 0.8s',
                    pointerEvents: 'none'
                  }}></div>
                </>
              )}
              
              <div style={{
                backgroundColor: isDragging ? '#dbeafe' : '#eff6ff',
                padding: '20px',
                borderRadius: '16px',
                transition: 'background-color 0.7s ease-out',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: isDragging ? '0 8px 16px rgba(59, 130, 246, 0.2)' : 'none',
                animation: 'iconFloat 3s ease-in-out infinite'
              }}>
                <CloudUpload 
                  size={48}
                  style={{
                    color: isDragging ? '#2563eb' : '#3b82f6',
                    transition: 'color 0.7s ease-out',
                    strokeWidth: 1.5
                  }}
                />
              </div>
            </div>

            <div style={{
              ...styles.title,
              transition: 'all 0.7s ease-out',
              color: isDragging ? '#2563eb' : '#1e293b',
              transform: isDragging ? 'scale(1.03)' : 'scale(1)'
            }}>
              {isDragging ? '✨ שחררי את החשבונית כאן' : translations.uploadInvoices}
            </div>
            
            <p style={{
              ...styles.subtitle,
              transition: 'all 0.5s ease-out',
              color: isDragging ? '#3b82f6' : '#64748b'
            }}>
              {isDragging ? 'שחררי כאן' : translations.dragAndDropPrompt}
            </p>
            
            <p style={styles.fileTypes}>
              <FileText 
                size={14} 
                style={{ 
                  display: 'inline', 
                  marginLeft: '6px', 
                  verticalAlign: 'middle' 
                }} 
              />
              {translations.supportedFormats}
            </p>
          </div>
        </div>
      </div>
    );
  };

export default DropZone;